import { render } from "./score_card_elements.html?vue&type=template&id=bdc1c98c&external"
import script from "./score_card_elements.js?vue&type=script&lang=js&external"
export * from "./score_card_elements.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__